import { render, staticRenderFns } from "./hallOfFamePage.vue?vue&type=template&id=b83450e0&scoped=true&"
import script from "./hallOfFamePage.vue?vue&type=script&lang=js&"
export * from "./hallOfFamePage.vue?vue&type=script&lang=js&"
import style0 from "./hallOfFamePage.vue?vue&type=style&index=0&id=b83450e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83450e0",
  null
  
)

export default component.exports